/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Canselectcontactcodes3Inputs */

const en_entity_canselectcontactcodes3 = /** @type {(inputs: Entity_Canselectcontactcodes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can Select Contact Codes`)
};

const de_entity_canselectcontactcodes3 = /** @type {(inputs: Entity_Canselectcontactcodes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann Kontakt Codes auswählen`)
};

/**
* | output |
* | --- |
* | "Can Select Contact Codes" |
*
* @param {Entity_Canselectcontactcodes3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_canselectcontactcodes3 = /** @type {((inputs?: Entity_Canselectcontactcodes3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Canselectcontactcodes3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_canselectcontactcodes3(inputs)
	return de_entity_canselectcontactcodes3(inputs)
});
export { entity_canselectcontactcodes3 as "entity_canSelectContactCodes" }